export default __webpack_public_path__ + "static/media/appfluencer-logo5-wtb.345e0923.png";